import React from 'react';

import { CancelStep } from '../../cancelModalSteps';

export interface WizardStepProps {
  name: CancelStep;
  skip?: boolean;
  children: React.ReactNode;
}

const WizardStep: React.FC<WizardStepProps> = ({ children }) => <>{children}</>;

export default WizardStep;
